import { createFileRoute } from '@tanstack/react-router';
import { SalesOrderNew } from '../../../../features/sales-invoicing/SalesOrderNew';

/** Create a sales order (BUILD_SPEC.md §5.7). */
export const Route = createFileRoute('/_authenticated/sales-invoicing/sales-orders/new')({
  component: SalesOrderNew,
});
